var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutroIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.613 19.193c-3.91 0-7.13-3.22-7.13-7.13 0-3.903 3.22-7.13 7.123-7.13 3.91 0 7.137 3.227 7.137 7.13 0 3.91-3.22 7.13-7.13 7.13zM9.665 15.66l1.948-1.429 1.948 1.43c.43.32.896.006.718-.527l-.766-2.29 1.962-1.408c.383-.274.3-.869-.273-.862l-2.413.028-.739-2.304c-.164-.513-.718-.513-.882 0l-.731 2.304-2.413-.028c-.56-.007-.67.581-.28.868l1.962 1.409-.766 2.283c-.171.526.294.848.725.526z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutroIcon);
export default __webpack_public_path__ + "static/media/outroIcon.c495041b6a0ed6fb223a120dfbd3abcb.svg";
export { ForwardRef as ReactComponent };